import { Navigate } from "react-router-dom";
import { isAuthenticated, isPasswordChangeRequired } from "@/lib/auth";

const ProtectedRoute = ({ children, allowPasswordChange = false }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/admin/login" replace />;
  }

  if (!allowPasswordChange && isPasswordChangeRequired()) {
    return <Navigate to="/admin/change-password" replace />;
  }

  return children;
};

export default ProtectedRoute;
